import exponent from "./exponent";

export default function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-format/src/precisionPrefix.js
// module id = ../../../../d3-format/src/precisionPrefix.js
// module chunks = 4